<template>
  <div v-loading="floorLoading" class="third-floor">
    <el-row v-if="false" :gutter="24">
      <el-col :span="6">
        <el-table
          :data="tableData.slice(0, 12)"
          border
          style="width: 100%"
          :row-class-name="tableRowClassName"
          v-loading="tableLoading"
          header-cell-class-name="floor-title"
        >
          <el-table-column align="center" prop="type" label="警报类型">
          </el-table-column>
          <el-table-column align="center" prop="number" label="报警数量">
          </el-table-column>
          <el-table-column align="center" prop="sum" label="点位总数">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col v-if="tableData.length >= 12" :span="6">
        <el-table
          :data="tableData.slice(12, 24)"
          border
          style="width: 100%"
          :row-class-name="tableRowClassName"
          header-cell-class-name="floor-title"
        >
          <el-table-column align="center" prop="type" label="警报类型">
          </el-table-column>
          <el-table-column align="center" prop="number" label="报警数量">
          </el-table-column>
          <el-table-column align="center" prop="sum" label="点位总数">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col v-if="tableData.length >= 24" :span="6">
        <el-table
          :data="tableData.slice(24, 36)"
          border
          style="width: 100%"
          :row-class-name="tableRowClassName"
          header-cell-class-name="floor-title"
        >
          <el-table-column align="center" prop="type" label="警报类型">
          </el-table-column>
          <el-table-column align="center" prop="number" label="报警数量">
          </el-table-column>
          <el-table-column align="center" prop="sum" label="点位总数">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col v-if="tableData.length >= 36" :span="6">
        <el-table
          :data="tableData.slice(36, tableData.length)"
          border
          style="width: 100%"
          :row-class-name="tableRowClassName"
          header-cell-class-name="floor-title"
        >
          <el-table-column align="center" prop="type" label="警报类型">
          </el-table-column>
          <el-table-column align="center" prop="number" label="报警数量">
          </el-table-column>
          <el-table-column align="center" prop="sum" label="点位总数">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div v-if="tabData.length > 0 && false" class="tab">
      <el-tag
        v-for="item in tabData"
        :key="item.value"
        :type="item.value === tabActive ? 'success' : 'info'"
        @click="tabChange(item.value)"
        >{{ item.name }}</el-tag
      >
    </div>
    <div
      v-if="!floorLoading"
      :style="{
        width: tableData[tabActive].length > 0 ? (tableData[tabActive].length + 1) * 120 : 840,
      }"
    >
      <el-table width="100%"  max-height="870" :data="floorData[tabActive]" border>
        <el-table-column
          v-if="floorData[tabActive] && floorData[tabActive].length > 0"
          align="center"
          prop="floor"
          width="120"
          label="楼层"
        >
        </el-table-column>
        <template v-for="(title, i) in tableData[tabActive]">
          <el-table-column
            :key="i"
            align="center"
            :label="title.type"
            class-name="col-left"
          >
            <template slot-scope="scope">
              <img
                v-if="scope.row.deviceData[title.deviceId]"
                :class="{
                  circle: true,
                  red: parseInt(scope.row.deviceData[title.deviceId]) > 0,
                }"
                :src="
                  parseInt(scope.row.deviceData[title.deviceId]) > 0
                    ? require('@/assets/fireFighting/'+ title.type +'-报警.png')
                    : require('@/assets/fireFighting/'+ title.type +'.png')
                "
              />
              <span
                :class="{ 's-center': !scope.row.deviceData[title.deviceId] }"
                >{{ scope.row.deviceData[title.deviceId] || "-" }}
              </span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
// import floorData from './ThirdFloor.json'
import { fireProtectionSystemSummaryOfFloor, fireProtectionSystemSummaryOfType } from '@/api/business/base/tenant/fireFightingSystem'
// const floordata = []
export default {
  data() {
    return {
      // 表头数据
      tableData: {
        '0': []
      },
      tableLoading: false,
      // 楼层数据
      floorData: {
        '0': []
      },
      floorLoading: false,
      tabData: [],
      tabActive: '0',
      deviceId: []
    }
  },
  computed: {
      newName() {
        return this.$route.query.type
      }
    },
  watch: {
    newName(val) {
        this.tabActive = val
      }
  },
  created() {

    this.tableLoading = true
    fireProtectionSystemSummaryOfType({ categoryId: 11 }).then(res => {
      this.tableLoading = false
      if (res.tabData) {
        this.tabData = res.tabData
        this.tabActive = this.$route.query.type
      }
      this.tableData = res
    }).then(() => {
      this.floorLoading = true
      fireProtectionSystemSummaryOfFloor({ categoryId: 11 }).then(res => {
        this.floorData = res
      }).then(() => {
        this.floorLoading = false
      }).catch(() => {
        this.floorLoading = false
      })
    }).catch(() => {
      this.tableLoading = false
    })


  },
  methods: {
    // tag切换
    tabChange(value){
      this.tabActive = value
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return 'success-row';
      }
      return '';
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  margin-bottom: 20px;
  .el-tag {
    margin-right: 20px;
  }
}
.el-table {
  margin-bottom: 40px;
  width: 1321px;
}
.circle {
  display: inline-block;
  vertical-align: middle;
  width: 25px;
  // height: 26px;
  // background-image: url("../../../../../assets/bg/fire_off.png");
  background-size: 100% 100%;
  margin-right: 18px;
}
// .red {
//   // background-image: url("../../../../../assets/bg/fire_on.png");
// }
/*  动画名称、动画完成时间  */

.red {
  -webkit-animation-name: magentaPulse;
  animation-name: magentaPulse;
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
/*  动画闪烁颜色  */
@keyframes magentaPulse {
  from {
    transform: scale(0.9) rotate(-3deg);
  }
  25% {
    transform: scale(0.9) rotate(3deg);
  }
  50% {
    transform: scale(1.1) rotate(-3deg);
  }
  80% {
    transform: scale(1.1) rotate(3deg);
  }
  to {
    transform: scale(1) rotate(0deg);
  }
}
@-webkit-keyframes magentaPulse {
  from {
    transform: scale(0.9) rotate(-3deg);
  }
  25% {
    transform: scale(0.9) rotate(3deg);
  }
  50% {
    transform: scale(1.1) rotate(-3deg);
  }
  80% {
    transform: scale(1.1) rotate(3deg);
  }
  to {
    transform: scale(1) rotate(0deg);
  }
}
</style>
<style lang="scss">
.third-floor {
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .floor-title {
    background-color: #fafafa;
  }
  /deep/ .el-table__fixed-body-wrapper {
    top: 44px !important;
  }
  .el-table td.is-center.col-left {
    text-align: left;
    padding-left: 8px;
    .s-center {
      display: block;
      text-align: center;
    }
  }
  .el-table .cell {
    overflow: inherit;
  }
}
</style>